<template>
	<div class="app-top-bar d-flex justify-center">
		<div v-if="shouldShowLeftSide" class="app-top-bar__left-side">
			<router-link v-if="getLogoUrl" class="app-top-bar__left-side__logo" :to="getLogoUrl">
				<img :src="headerLogo" alt="Logo" class="app-top-bar__logo" />
				<span class="app-top-bar__title">{{ appTitle }}</span>
			</router-link>
		</div>
		<div class="app-top-bar__right-side" :style="rightSideStyles">
			<div class="app-top-bar__right-side__container">
				<button type="button" v-if="showMobileMenuButton" @click="mobileMenuClick">
					<v-icon> mdi-menu</v-icon>
				</button>
				<router-link
					v-if="!shouldShowLeftSide"
					class="app-top-bar__right-side__logo"
					:to="getLogoUrl"
				>
					<img :src="headerLogo" alt="Logo" class="app-top-bar__logo" />
				</router-link>
				<AppTopInfo :showEditModal="showEditModal" />
				<Menu
					v-if="!isMobileSearchEnabled"
					:is-auth="isAuth"
					:opacity-routes="opacityRoutes"
					:profile-settings="menuItems"
					:categories="categoriesList"
					:user-avatar="userProfileAvatar"
				/>
				<div
					class="app-top-bar__right-side__container__banner"
					v-if="shouldRightBannerShow && !shouldBeFullWidth"
				>
					<AdBanner v-if="shouldShowSidebar" />
				</div>
			</div>
		</div>
		<MobileMenu
			:display-menu="drawer"
			:is-auth="isAuth"
			:profile-settings="menuItems"
			:categories="categoriesList"
			:user-avatar="userProfileAvatar"
			@closeMenu="toggleMobileMenu"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import MainLogo from '@/assets/images/logo.png'
import profileIcon from '@/assets/images/profile-icon.svg'
import settingsIcon from '@/assets/images/settings-icon.svg'
import logoutIcon from '@/assets/images/logout-icon.svg'

import MobileMenu from '@/components/MobileMenu'
import Menu from '@/components/Menu'
import Dwh from '@/mixins/Dwh'
import menuList from "@/utils/menuList";
import AppSearch from '@/components/Layouts/parts/AppSearch.vue'
import AppTopInfo from '@/components/Layouts/parts/AppTopInfo.vue'
import AdBanner from '@/components/Layouts/parts/AdBanner.vue'
import LocalStorageService from '@/services/local-storage.service'

export default {
	name: 'TopBar',
	mixins: [Dwh, menuList],
	components: {
		MobileMenu,
		Menu,
		AppSearch,
		AppTopInfo,
		AdBanner,
	},
	data() {
		return {
			MainLogo: MainLogo,
			selectedCategory: null,
			navOpacity: {
				left: false,
			},
			drawer: false,
			category: null,
			navOp: false,
			isActive: false,
			mobileSearch: false,
			opacityRoutes: ['CreatePost', 'chat', 'Notifications', 'MapPage'],
		}
	},
	computed: {
		...mapGetters('category', ['isCategoryLoading', 'categories']),
		...mapGetters('auth', ['isAuthenticated', 'profile','UserLogInCategories']),
		...mapGetters('settings', [ 'ci_cd', 'baseCore']),
		...mapGetters('advertisement', ['isMyPost', 'isMyForumPost']),
		...mapGetters('settings', ['web']),
    ...mapGetters('event',['survey']),
		shouldBeFullWidth() {
			return this.$route.meta.fullWidth
		},
    isSurvey() {
      return this.$route.query.type === 'quiz' && this.$route.name === 'survey'
    },
		shouldShowSidebar() {
      if (this.isSurvey) return false
			return this.$route.meta.sidebar && this.$vuetify.breakpoint.width >= 1450
		},
		shouldRightBannerShow() {
			if (!this.web) return false
			return (
				!!this.web.banner_image &&
				this.$vuetify.breakpoint.lgAndUp &&
				this.$vuetify.breakpoint.width >= 1250
			)
		},
		showEditModal() {
			return (
				(this.$route.name === 'posts-by-id' && this.isMyPost) ||
				this.$route.name === 'event-session-questions'
			)
		},
		categoriesList: function () {
			return this.categories
		},
		isAuth: function () {
			return this.isAuthenticated
		},
		userProfileAvatar: function () {
			return this.profile?.user_logo
		},
		rightSideStyles() {
      return {
				justifyContent: 'space-between',
				width: '65%',
				paddingLeft: this.shouldShowLeftSide ? '100px' : '0',
			}
		},
		headerLogo() {
			if (this.ci_cd) {
				return this.ci_cd.app_icon
			}

			return MainLogo
		},

		appTitle() {
			if (this.ci_cd) {
				return this.ci_cd.device_name
			}

			return 'Clowder Web'
		},
		menuItems() {
			const items = [
				{
					id: 1,
					name: 'Profile',
					action: () => {
						this.sendTrigger({
							category: 'Navigation',
							action: 'menu_profile',
							module: 'Menu',
							title: 'Profile',
						})
					},
					path: '/my-account',
					icon: profileIcon,
				},
				{ id: 2, name: 'Logout', action: this.exit, icon: logoutIcon },
			]
      return items
		},
		showMobileMenuButton() {
			return this.$vuetify.breakpoint.width < 919
		},
		isTabletOrMobile() {
			return this.$vuetify.breakpoint.width < 769
		},
		isMobileSearchEnabled() {
			return this.isTabletOrMobile && this.mobileSearch
		},
		shouldShowLeftSide() {
			return this.$vuetify.breakpoint.width >= 920
		},
	},
	watch: {
		selectedCategory: {
			handler(val) {
				this.categoryId = val ? this.categories[val].id : null
				this.categoryHandler(this.categoryId)
			},
			deep: true,
		},
		$route() {
			this.navOpacity.left = this.opacityRoutes.includes(this.$route.name)
		},
	},
	methods: {
		...mapActions('category', ['fetchCategories', 'setCategory']),
		...mapActions('auth', ['logout']),
		async exit() {
			this.logout()
		},
		categoryHandler(id) {
			if (this.$route.name !== 'Home') {
				this.$router.push({ name: 'Home' })
			}

			this.setCategory(id)

			this.$emit('nav-change', {
				category: id,
			})
		},
		toggleMobileMenu(value) {
			this.drawer = value
		},
		mobileMenuClick() {
			this.sendTrigger({
				category: 'Navigation',
				action: 'menu_click',
				module: 'Menu',
			})
			this.toggleMobileMenu(true)
		},
	},
}
</script>

<style lang="scss">
.app-top-bar {
	position: sticky;
	top: 0;
	z-index: 100;
	display: flex;
	justify-content: center;
	background-color: #ffffff;
	height: 64px;
	border-bottom: 1px solid #e2e2e2;
	@media (max-width: 920px) {
		padding: 0 20px;
	}
	&__logo {
		width: 40px;
		height: 40px;
		border-radius: 8px;
	}
	&__title {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 20px;
		line-height: 22px;
		letter-spacing: 0;
		color: var(--accent-color);
	}

	&__left-side {
		display: flex;
		justify-content: flex-end;
		width: 35%;
		padding-left: 20px;
		border-right: 1px solid #e2e2e2;

		&__logo {
			width: 294px;
			display: flex;
			align-items: center;
			cursor: pointer;
			text-decoration: unset;
			gap: 10px;
			font-family: Inter, sans-serif !important;
			font-weight: 700 !important;
			font-size: 20px !important;
			line-height: 22px !important;
			letter-spacing: 0 !important;
			color: #002855 !important;
		}
	}

	&__right-side {
		display: flex;
		width: 65%;
		justify-content: flex-start;
		padding-right: 20px;
		align-items: center;
		gap: 8px;
		position: relative;
		@media (max-width: 920px) {
			max-width: 555px;
			width: 100% !important;
			display: flex;
			align-items: center;
			padding: 0;
		}
		&__container {
			position: relative;
			display: flex;
			gap: 8px;
			justify-content: space-between;
			max-width: 846px;
			width: 100%;
			&__banner {
				position: absolute;
				right: 0;
				top: 73px;
			}
		}

		&__logo {
			width: 100%;
			display: flex;
			align-items: center;
			cursor: pointer;
			text-decoration: unset;
			gap: 10px;
			font-family: Inter, sans-serif !important;
			font-weight: 700 !important;
			font-size: 20px !important;
			line-height: 22px !important;
			letter-spacing: 0 !important;
			color: #002855 !important;
		}
	}
}
</style>
